import { useSuspenseQuery } from "@tanstack/react-query";

import { authService } from "services/auth";
import { ReactQueryKeysGlobal } from "services/queryKeys";

export const useLoggedInUser = () => {
  const { data } = useSuspenseQuery({
    queryKey: [ReactQueryKeysGlobal.isLoggedIn],
    queryFn: () => {
      return process.env.REACT_APP_LITE ? false : authService.isLoggedIn();
    },
  });

  return {
    isLoggedIn: data,
  };
};
